/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import vkLogo from '../../assets/img/vk.png';
import tgLogo, { ReactComponent as Telegram } from '../../assets/img/telegram.svg';
import legalLinks from '../../constants/legalLinks';
import maxLogo, { ReactComponent as Max } from '../../assets/img/max.svg';

const links = [
  {
    href: legalLinks.telegram,
    child: <Telegram />,
    key: 'telegram',
  },
  {
    href: legalLinks.max,
    child: <Max />,
    key: 'max',
  },
];

export default function Footer() {
  const handleClick = link => {
    window.open(link, '_blank');
  };

  return (
    <footer className="footer-container">
      <div className="footer">
        <div className="footer__first-line">
          <div className="footer__contacts">
            <a className="footer__contacts__tel" href="tel:+7(931)108-07-21">
              +7 (931) 108 - 07 - 21
            </a>
            <div className="footer__contacts__schedule">
              <div className="footer__contacts__schedule__online" />
              <div className="footer__contacts__schedule__container">
                <div className="footer__contacts__schedule__text">
                  На связи с 10:00 по 20:00 по Мск
                </div>
              </div>
            </div>
            <div className="footer__contacts__messengers">
              {!!links.length &&
                links.map(link => (
                  <a
                    className="footer__contacts__messengers__button"
                    href={link.href}
                    rel="noreferrer"
                    target="_blank"
                    key={link.key}
                  >
                    {link.child}
                  </a>
                ))}
            </div>
          </div>
          <div className="footer__faq">
            <a href={legalLinks.main} className="footer__faq__text">
              Как можно учиться в Мостике?
            </a>
            <a href={legalLinks.about} className="footer__faq__text">
              Все о Мостике
            </a>
          </div>
          <div className="footer__social">
            <div className="footer__social__links">
              <button
                type="button"
                className="footer__social__link"
                onClick={() => handleClick(legalLinks.telegram)}
              >
                <img src={tgLogo} alt="tg logo" className="footer__social__logo" />
              </button>
              <button
                type="button"
                className="footer__social__link"
                onClick={() => handleClick(legalLinks.vk)}
              >
                <img src={vkLogo} alt="vk logo" className="footer__social__logo" />
              </button>
              <button
                type="button"
                className="footer__social__link"
                onClick={() => handleClick(legalLinks.maxTop)}
              >
                <img src={maxLogo} alt="ok logo" className="footer__social__logo" />
              </button>
            </div>
          </div>
        </div>
        <div className="footer__divider" />
        <div className="footer__info">
          <div className="footer__info__address">
            Москва, Большая Марфинская улица, 1к3 Округ СВАО, Район Марфино
          </div>
          <div className="footer__info__docs">
            <a
              className="footer__info__privacy"
              href={legalLinks.license}
              rel="noreferrer"
              target="_blank"
            >
              Лицензия
            </a>
            <a
              className="footer__info__privacy"
              href={legalLinks.official}
              rel="noreferrer"
              target="_blank"
            >
              Сведения об образовательной организации
            </a>
            <a
              className="footer__info__privacy"
              href={legalLinks.offer}
              rel="noreferrer"
              target="_blank"
            >
              Договор-оферта
            </a>
            <a
              className="footer__info__privacy"
              href={legalLinks.personalDataConsent}
              rel="noreferrer"
              target="_blank"
            >
              Согласие на обработку персональных данных
            </a>
            <a
              className="footer__info__privacy"
              href={legalLinks.privacyPolicy}
              rel="noreferrer"
              target="_blank"
            >
              Политика конфиденциальности
            </a>
            <a
              className="footer__info__privacy"
              href={legalLinks.userAgreement}
              rel="noreferrer"
              target="_blank"
            >
              Пользовательское соглашение
            </a>
          </div>
          <div className="footer__info__copyright">
            <div className="footer__info__copyright__text">
              © Мостик, {new Date().getFullYear()}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
